import { IRetailerDetail, IRetailerPIC } from '@models/retailer.model';
import { TableColumn } from '@shared/interface/table.interface';
import { PageLink } from '@metronic/layout';

// For Table List
export const TerverifikasiTableColumns: TableColumn[] = [
  {
    key: 'code',
    title: 'ID Retailer',
    isSortable: true,
  },
  {
    key: 'name',
    title: 'Nama Toko',
    isSortable: false,
  },
  {
    key: 'owner_name',
    title: 'Nama Pemilik',
    isSortable: false,
  },
  {
    key: 'area_manager_name',
    title: 'MARKETING EXECUTIVE',
    isSortable: false,
  },
  {
    key: 'area_name',
    title: 'Nama Area',
    isSortable: false,
  },
  {
    key: 'status',
    title: 'Status',
    isSortable: false,
  },
  {
    key: 'is_mac',
    title: 'Kemitraan',
  },
  {
    key: 'createdDate',
    title: 'Tanggal Approve',
    isSortable: true,
  },
  {
    key: 'actions',
    title: 'Action',
  },
];

export const TerverifikasiNonActiveColumn: TableColumn[] = [
  {
    key: 'code',
    title: 'ID Retailer',
    isSortable: true,
  },
  {
    key: 'name',
    title: 'Nama Toko',
    isSortable: false,
  },
  {
    key: 'owner_name',
    title: 'Nama Pemilik',
    isSortable: false,
  },
  {
    key: 'area_manager_name',
    title: 'MARKETING EXECUTIVE',
    isSortable: false,
  },
  {
    key: 'area_name',
    title: 'Nama Area',
    isSortable: false,
  },
  {
    key: 'status',
    title: 'Status',
    isSortable: false,
  },
  {
    key: 'is_mac',
    title: 'Kemitraan',
  },
  {
    key: 'createdDate',
    title: 'Tanggal Approve',
    isSortable: true,
  },
  {
    key: 'actions',
    title: 'Action',
  },
];

export const PendingRegistrationColumns: TableColumn[] = [
  {
    key: 'code',
    title: 'ID Retailer',
    isSortable: true,
  },
  {
    key: 'name',
    title: 'Nama Toko',
    isSortable: false,
  },
  {
    key: 'owner_name',
    title: 'Pemilik',
    isSortable: false,
  },
  {
    key: 'area_name',
    title: 'Nama Area',
    isSortable: false,
  },
  {
    key: 'status',
    title: 'Status',
    isSortable: false,
  },
  {
    key: 'submitted_by',
    title: 'Diajukan Oleh',
    isSortable: false,
  },
  {
    key: 'createdDate',
    title: 'Tanggal Pengajuan',
    isSortable: true,
  },
];

export const PendingSubmissionTableColumns: TableColumn[] = [
  {
    key: 'code',
    title: 'ID Retailer',
    isSortable: true,
  },
  {
    key: 'name',
    title: 'Nama Toko',
    isSortable: false,
  },
  {
    key: 'owner_name',
    title: 'Pemilik',
    isSortable: false,
  },
  {
    key: 'area_name',
    title: 'Area',
    isSortable: false,
  },
  {
    key: 'status',
    title: 'Status',
    isSortable: false,
  },
  {
    key: 'submitted_by',
    title: 'Diajukan Oleh',
    isSortable: false,
  },
  {
    key: 'createdDate',
    title: 'Tanggal Pengajuan',
    isSortable: true,
  },
];

export const RejectTableColumns: TableColumn[] = [
  {
    key: 'code',
    title: 'ID Retailer',
    isSortable: true,
  },
  {
    key: 'name',
    title: 'Nama Toko',
    isSortable: false,
  },
  {
    key: 'owner_name',
    title: 'Nama Pemilik',
    isSortable: false,
  },
  {
    key: 'area_manager_name',
    title: 'Nama Regional Head',
    isSortable: false,
  },
  {
    key: 'area_name',
    title: 'Nama Area',
    isSortable: false,
  },
  {
    key: 'status',
    title: 'Status',
    isSortable: false,
  },
  {
    key: 'createdDate',
    title: 'Tanggal Submit',
    isSortable: true,
  },
];

// For Detail
export const getLabelList = (value: IRetailerDetail) => {
  return [
    {
      icon: './assets/media/icons/ic_retailer.svg',
      value: value.code,
    },
  ];
};

export const getDetailRetailerPIC = (value: IRetailerPIC) => {
  return [
    {
      label: 'Marketing Executive',
      key: 'name',
      value: value.name ?? '-',
    },
    {
      label: 'No. Telephone',
      key: 'phone',
      value: value.phone ?? '-',
    },
    {
      label: 'Field Assistant',
      key: 'fa_name',
      value: value.fa_name ?? '-',
    },
    {
      label: 'No. Telephone',
      key: 'fa_phone',
      value: value.fa_phone ?? '-',
    },
  ];
};

export const getDetailRetailer = (value: IRetailerDetail) => {
  return [
    {
      label: 'Area',
      key: 'area_name',
      value: value.area_name,
    },
    {
      label: 'Sub Area',
      key: 'sub_area_name',
      value: value.sub_area_name,
    },
    {
      label: 'Nama Pemilik',
      key: 'owner_name',
      value: value.owner_name,
    },
    {
      label: 'NIK',
      key: 'owner_nik',
      value: value.owner_nik,
    },
    {
      label: 'NPWP',
      key: 'npwp',
      value: value.npwp,
    },
    {
      label: 'No Telephone Pemilik',
      key: 'owner_phone_number',
      value: value.owner_phone_number,
    },
    {
      label: 'Email Pemilik',
      key: 'owner_email',
      value: value.owner_email,
    },
    {
      label: 'Alamat Lengkap Pemilik',
      key: ['owner_full_address', 'owner_sub_district', 'owner_district', 'owner_regency', 'owner_province'],
      value: value.owner_full_address + ', ' + value.owner_sub_district + ', ' + value.owner_district + ', ' + value.owner_regency + ', ' + value.owner_province,
    },
  ];
};

export const getDetailVenture = (value: IRetailerDetail) => {
  return [
    {
      label: 'Nama Toko',
      key: 'venture_name',
      value: value.venture_name,
    },
    {
      label: 'Alamat Lengkap Toko',
      key: ['venture_full_address', 'venture_sub_district', 'venture_district', 'venture_regency', 'venture_province'],
      value: value.venture_full_address + ', ' + value.venture_sub_district + ', ' + value.venture_district + ', ' + value.venture_regency + ', ' + value.venture_province,
    },
  ];
};

export const getDocument = (value: IRetailerDetail) => {
  return [
    {
      label: 'KTP Pemilik',
      key: 'owner_ktp_image_url',
      name: 'CARD_FIELD_NIK',
      value: value.owner_ktp_image_url,
    },
    {
      label: 'Swafoto',
      key: 'owner_ktp_selfie_image_url',
      name: 'CARD_FIELD_SWAFOTO',
      value: value.owner_ktp_selfie_image_url,
    },
    {
      label: 'NPWP',
      key: 'npwp_image_url',
      name: 'CARD_FIELD_NPWP',
      value: value.npwp_image_url,
    },
  ];
};

// Page Links
export const BreadcrumbParent: PageLink[] = [
  {
    title: 'Retailer',
    path: '',
    isActive: false,
  },
  {
    title: '',
    path: '',
    isActive: false,
    isSeparator: true,
  },
];
